wbApp.filter('wbRfidAccessGroupTimeScheduleDayFilter', [function () {

    function printPeriod(line, period) {
        var ret = "";

        if (!!period && (period.endTime - period.startTime) > 0) {

            if (line !== "") {
                ret = ret + ", ";
            }

            var startHour = Math.floor(period.startTime / 60);
            var startMinute = Math.floor(period.startTime % 60);
            var endHour = Math.floor(period.endTime / 60);
            var endMinute = Math.floor(period.endTime % 60);

            ret = ret + "" + ("0" + startHour).slice(-2) + ":" + ("0" + startMinute).slice(-2);
            ret = ret + " - " + ("0" + endHour).slice(-2) + ":" + ("0" + endMinute).slice(-2);
        }

        return ret;
    }

    return function (input) {

        var ret = "";

        ret = ret + printPeriod(ret, input.period0);
        ret = ret + printPeriod(ret, input.period1);
        ret = ret + printPeriod(ret, input.period2);
        ret = ret + printPeriod(ret, input.period3);
        ret = ret + printPeriod(ret, input.period4);

        if (ret !== "") {
            return "(" + ret + ")"
         }

        return ret;
    };
}]);